module.exports = __webpack_public_path__ + "static/media/iconLeft.dc758551.svg";